import React from 'react';
import FilterList from '../../../components/user/vivero/viveroFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const ViveroListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

ViveroListPage.propTypes = {};

export default ViveroListPage;
